export enum ShotCategory {
  EVEN = 'EVEN',
  SUP = 'SUP',
  PENALTY = 'PENALTY',
  OUTCOME = 'OUTCOME'
}

export enum ShotOutcome {
    GOAL = 'GOAL', 
    SAVED = 'SAVED',
    MISSED = 'MISSED',
    BLOCKED = 'BLOCKED',
    NULL = 'NULL'
}

export enum EvenShot {
    P1 = '1',
    P2 = '2', 
    P3 = '3', 
    P4 = '4',
    P5 = '5',
    CB = 'CB', 
    Rip = 'CF'
}

export enum MenUpShot {
    P1 = '1',
    P2 = '2', 
    P3 = '3', 
    P4 = '4',
    P5 = 'P5',
    P6 = 'P6', 
    Rip = 'CF'
}

